module.exports = __webpack_public_path__ + "static/media/harps.6d6dc731.png";